<template>
    <div class="filter-select">
        <el-select v-model="value"  :selectedValue="selectedValue" :placeholder="placeholder" @change="change(value)" ref="select" clearable>
            <div slot="prefix">
                <div class="label">{{label}}</div>
            </div>
            <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                value:null,
            }
        },
        methods:{
            clear(){
                this.value  = null
            }
        },
        watch:{
            selectedValue(val){
                this.value  = val
            }
        },
        props:{
            change:{
              type:Function,
              default() {
                  return (value)=>{};
              }
            },
            label:{
                type: [String,Number],
                default() {
                    return '';
                }
            },
            selectedValue:{
                type: [String,Number],
                default() {
                    return '';
                }
            },
            placeholder:{
                type: [String,Number],
                default() {
                    return '';
                }
            },
            options:{
                type:Array,
                default(){
                    return []
                }
            },

        }
    }
</script>

<style lang="scss">
    .filter-select{
        width: 250px;
        position: relative;
        display: inline-block;
        line-height: 34px;
        border-bottom: 1px solid #F5F5F5;
        .label{
            display: inline-block;
            font-size: 16px;
            @include SourceHanSerifSC-bold;
        }
        .value-box{
            position: absolute;
            right: 0;
        }
        .el-select{
            width: 100%;
            .el-input__prefix{
                color: $title-color;
            }

            .el-input{
                input{
                    width: 100%;
                    border: none;
                    height: 34px;
                    padding-left: 45px;
                }
            }
            .el-input__suffix-inner{
                i{
                    color: #8F8F8F;
                }
            }
        }

    }
</style>